import React from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Label,
  Input,
  Table,
  Card,
  CardBody,
  CardFooter,
  Row,
  Col,
} from 'reactstrap';
import { CLOUDINARY_THUMB } from '../../helpers/cloudinaryConstants';
import GNAddressFormat from '../../helpers/GNAddressFormat';

const UserAttachment = ({
  setBusinessSearch,
  businessSearch,
  handleBusinessSearch,
  businessResults,
  handleBusinessClick,
}) => {
  const renderResults = () => {
    return businessResults.map(business => (
      <tr
        // onClick={() => {
        //   this.onClickBusiness(business.id);
        // }}
        key={business.id}
        className='user-table__item'>
        <td className='text-center'>
          <div className='avatar'>
            <img
              src={`${CLOUDINARY_THUMB}/${business.avatar.image.cloudinaryId}`}
              className='img-avatar'
              alt={business.name}
            />
          </div>
        </td>
        <td>
          <div>{business.name}</div>
        </td>
        <td>
          <div> {GNAddressFormat(business.location.address)}</div>
        </td>
        <td className='text-center'>
          <Row>
            <Col>
              <div
                className='bold-link'
                onClick={() => handleBusinessClick(business.id)}>
                Claim As Owner
              </div>
            </Col>
            <Col>
              <div
                className='bold-link'
                onClick={() => handleBusinessClick(business.id)}>
                Claim as Manager
              </div>
            </Col>
          </Row>
        </td>
      </tr>
    ));
  };
  return (
    <Card>
      <CardBody>
        <FormGroup>
          <Label htmlFor='business name'>Business Name</Label>
          <Input
            type='text'
            name='businessName'
            id='business-name-input'
            placeholder='Enter Business Name'
            value={businessSearch.businessName}
            onChange={e =>
              setBusinessSearch({
                ...businessSearch,
                [e.target.name]: e.target.value,
              })
            }
          />
        </FormGroup>
        <FormGroup>
          <Label htmlFor='business city'>Business City</Label>
          <Input
            type='text'
            name='businessCity'
            id='business-city-input'
            placeholder='Enter Business City'
            value={businessSearch.businessCity}
            onChange={e =>
              setBusinessSearch({
                ...businessSearch,
                [e.target.name]: e.target.value,
              })
            }
          />
        </FormGroup>
        <Button color='primary' onClick={() => handleBusinessSearch()}>
          Search
        </Button>
      </CardBody>
      {businessResults.length ? (
        <Table
          hover
          responsive
          className='table-outline mb-0 d-none d-sm-table user-table'>
          <thead className='thead-light'>
            <tr>
              <th className='text-center'>
                <i className='icon-people' />
              </th>
              <th>Name</th>
              <th className='text-center'>City/State</th>
              <th className='text-center'>Claim Business</th>
            </tr>
            {renderResults()}
          </thead>
          <tbody />
        </Table>
      ) : (
        ''
      )}
    </Card>
  );
};

export default UserAttachment;



// WEBPACK FOOTER //
// ./src/views/Components/UserAttachment.js